import VSkeletonLoader from './VSkeletonLoader';
export { VSkeletonLoader };
export default VSkeletonLoader;
//# sourceMappingURL=index.js.map